import { reactive } from 'vue'

// 헤더 nav 버튼과 모바일 하단 탭바("주문") 양쪽에서 같은 계산기 모달을
// 열 수 있게 하는 전역 상태.
export const orderModalState = reactive({ open: false })

export function openOrderModal() {
  orderModalState.open = true
}
